export const firebaseConfig = {
    apiKey: "AIzaSyAyTjLk9Xc3545OdLHQsWvuC-lFH676AiI",
    authDomain: "grade-production-admin.firebaseapp.com",
    projectId: "grade-production-admin",
    storageBucket: "grade-production-admin.appspot.com",
    messagingSenderId: "627527155119",
    appId: "1:627527155119:web:efc66672db1ebd5a69c35a"
  };